export default __webpack_public_path__ + "static/media/37_mobile.c97e0ae9.jpg";